var commonUtil = {};


/**
 * 深拷贝
 * 还需要针对不同的数据类型进行完善。
 * @param target
 * @returns {*|*|*}
 */
commonUtil.deepCopy = function (target) {
    let copyed_objs = [];//此数组解决了循环引用和相同引用的问题，它存放已经递归到的目标对象
    //TODO  还需要针对不同的数据类型进行完善。
    function _deepCopy(target) {
        if ((typeof target !== 'object') || !target) {
            return target;
        }
        for (let i = 0; i < copyed_objs.length; i++) {
            if (copyed_objs[i].target === target) {
                return copyed_objs[i].copyTarget;
            }
        }
        let obj = {};
        if (Array.isArray(target)) {
            obj = [];//处理target是数组的情况
        }
        copyed_objs.push({target: target, copyTarget: obj})
        let targetKeys = Object.keys(target);
        for (let index in targetKeys) {
            let key = targetKeys[index];
            if (obj[key]) {
                return;
            }
            obj[key] = _deepCopy(target[key]);
        }
        return obj;
    }

    return _deepCopy(target);
};

/**
  * 状态过滤器
  * @param obj
  * @returns {string}
  */
commonUtil.statusFilter = function (obj) {
    let result = "无订单状态信息";
    switch (obj) {
        case 1:
            result = "已保存";
            break;
        case 2:
            result = "已审核";
            break;
        case 3:
            result = "已完成";
            break;
        case 4:
            result = "已关闭";
            break;
        case 5:
            result = "部分收货";
            break;
        case 6:
            result = "审核中";
            break;
        case 7:
            result = "已驳回";
            break;
        default:
            break;
    }
    return result;

};

/**
  * 订单类型过滤器
  * @param obj
  * @returns {string}
  */
commonUtil.classTypeFilter = function (obj) {
    let result = "无订单类型信息";
    switch (obj) {
        case 'P01':
            result = "供应商采购订单";
            break;
        case 'P02':
            result = "配送采购订单";
            break;
        case 'P03':
            result = "供应商采购退单";
            break;
        case 'P04':
            result = "配送采购退单";
            break;
        default:
            break;
    }
    return result;
};


/**
  * 订单来源过滤器
  * @param obj
  * @returns {string}
  */
commonUtil.sourceFilter = function (obj) {
    let result = "无订单来源信息";
    switch (obj) {
        case '1':
            result = "手工创建";
            break;
        case '2':
            result = "自动同步";
            break;
        default:
            break;
    }
    return result;
};

/**
  * 日期过滤器
  * @param obj
  * @returns {*}
  */
commonUtil.dayFilter = function (obj) {
    if (obj == null || typeof obj === "undefined") {
        return "";
    }
    let date = moment(obj).format('YYYY-MM-DD');
    return date;
};

/**
  * 时间过滤器
  * @param obj
  * @returns {*}
  */
commonUtil.dateFilter = function (obj) {
    if (obj == null || typeof obj === 'undefined' || obj === '') {
        return "";
    }
    let date = moment(obj).format('YYYY-MM-DD HH:mm:ss');
    return date;
};

/**
  * 小数点,换算为百分比
  * @param obj
  * @returns {*}
  */
commonUtil.taxRateFilter = function (obj) {
    if (obj == null || typeof obj === "undefined") {
        return "";
    } else {
        return commonUtil.Mul(obj, 100);
    }
};

commonUtil.numberShowFilter = function (obj) {
    if (obj == null || typeof obj === "undefined") {
        return "无";
    } else {
        return obj;
    }
};


/**
  * 订货包装初始化
  * @returns {*[]}
  */
commonUtil.packageTypeHandle = function () {
    // 订货包装
    let packageType = [
        {key: "EA", value: "EA"},
        {key: "KG", value: "KG"},
        // {key: "G", value: "G"},
        // {key: "MG", value: "MG"},
    ]
    //订货单位初始化
    //H开头遍历
    let type = ["H", "S", "X"];
    for (let m = 0, n = type.length; m < n; m++) {
        for (let i = 0; i < 99; i++) {
            let obj = {
                key: type[m] + ('0' + (i + 1)).slice(-2),
                value: type[m] + ('0' + (i + 1)).slice(-2),
            };
            packageType.push(obj);
        }
    }

    return packageType;
};


//订货包装系数换算
commonUtil.packageNum = function (orderPack) {
    if (!orderPack || typeof orderPack === "undefined") {
        return "0";
    }
    //系数
    let num = "0";
    //换算单位
    if ("KG" === orderPack.toUpperCase() || "EA" === orderPack.toUpperCase()) {
        num = "1";
    } else if ("G" === orderPack.toUpperCase()) {
        num = "0.001"
    } else if ("MG" === orderPack.toUpperCase()) {
        num = "0.000001"
    } else if (orderPack.substr(0, 1) === "H") {
        //倍数
        num = String(orderPack.substr(1, 2) * 10);
    } else if (orderPack.substr(0, 1) === "S") {
        //倍数
        num = String(orderPack.substr(1, 2) * 100);
    } else if (orderPack.substr(0, 1) === "X") {
        //倍数
        num = String(orderPack.substr(1, 2) * 1000);
    }
    return num;
};

//订货包装对应的基本包装
commonUtil.packageBaseUnit = function (orderPack) {
    if (orderPack == null || typeof orderPack === "undefined") {
        return null;
    }
    //系数
    let baseUnit = null;
    //换算单位
    if ("KG" === orderPack.toUpperCase() || "EA" === orderPack.toUpperCase()) {
        baseUnit = "KG";
    } else if ("EA" === orderPack.toUpperCase()) {
        baseUnit = "EA";
    } else if ("G" === orderPack.toUpperCase()) {
        baseUnit = "KG";
    } else if ("MG" === orderPack.toUpperCase()) {
        baseUnit = "KG";
    } else if (orderPack.substr(0, 1) === "H") {
        baseUnit = "EA";
    } else if (orderPack.substr(0, 1) === "S") {
        baseUnit = "EA";
    } else if (orderPack.substr(0, 1) === "X") {
        baseUnit = "EA";
    }
    return baseUnit;
};


commonUtil.priceFormat = function (num) {
    if (num == 0) {
        return "0.00";
    }

    if (!num) {
        return "0.00";
    }
    return commonUtil.medusaFormat(num, 2);
};
//浮点数保留小数点后面几位
commonUtil.medusaFormat = function (str, num) {
    if (str === null || str === "" || typeof str === "undefined" || isNaN(str)) {
      return '';
    }

    let formatValue = 0;

    //格式化小数点位数
    if (num + '' == '0') {
        formatValue = Math.round(parseFloat(str));
    } else {
        formatValue = parseFloat(str).toFixed(num);
    }
    return formatValue;

};

commonUtil.Mul = function (arg1, arg2) {
    let r1 = arg1.toString(), r2 = arg2.toString(), m, resultVal, d = arguments[2];
    m = (r1.split(".")[1] ? r1.split(".")[1].length : 0) + (r2.split(".")[1] ? r2.split(".")[1].length : 0);
    resultVal = Number(r1.replace(".", "")) * Number(r2.replace(".", "")) / Math.pow(10, m);
    return typeof d !== "number" ? Number(resultVal) : Number(resultVal.toFixed(parseInt(d)));
};


commonUtil.Div = function (arg1, arg2) {
    let r1 = arg1.toString(), r2 = arg2.toString(), m, resultVal, d = arguments[2];
    m = (r2.split(".")[1] ? r2.split(".")[1].length : 0) - (r1.split(".")[1] ? r1.split(".")[1].length : 0);
    resultVal = Number(r1.replace(".", "")) / Number(r2.replace(".", "")) * Math.pow(10, m);
    return typeof d !== "number" ? Number(resultVal) : Number(resultVal.toFixed(parseInt(d)));
};

commonUtil.Sub = function (arg1, arg2) {
    return this.Add(arg1, -Number(arg2), arguments[2]);
};

commonUtil.Add = function (arg1, arg2) {
    arg1 = arg1.toString(), arg2 = arg2.toString();
    let arg1Arr = arg1.split("."), arg2Arr = arg2.split("."), d1 = arg1Arr.length == 2 ? arg1Arr[1] : "",
        d2 = arg2Arr.length == 2 ? arg2Arr[1] : "";
    let maxLen = Math.max(d1.length, d2.length);
    let m = Math.pow(10, maxLen);
    let result = Number(((arg1 * m + arg2 * m) / m).toFixed(maxLen));
    let d = arguments[2];
    return typeof d === "number" ? Number((result).toFixed(d)) : result;
};

commonUtil.guid = function () {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    // return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4());
};

commonUtil.packageNum = function (orderPack) {
    if (!orderPack || typeof orderPack === "undefined") {
        return "0";
    }
    //系数
    let num = "0";
    //换算单位
    if ("KG" === orderPack.toUpperCase() || "EA" === orderPack.toUpperCase()) {
        num = "1";
    } else if ("G" === orderPack.toUpperCase()) {
        num = "0.001"
    } else if ("MG" === orderPack.toUpperCase()) {
        num = "0.000001"
    } else if (orderPack.substr(0, 1) === "H") {
        //倍数
        let tempNum = orderPack.substr(1, 2);
        num = String(tempNum * 10);
    } else if (orderPack.substr(0, 1) === "S") {
        //倍数
        let tempNum = orderPack.substr(1, 2);
        num = String(tempNum * 100);
    } else if (orderPack.substr(0, 1) === "X") {
        //倍数
        let tempNum = orderPack.substr(1, 2);
        num = String(tempNum * 1000);
    }
    return num;
};

/**
  * 参数校验
  * @param paramOptions
  * @param obj
  */
commonUtil.validateParams = function (paramOptions, obj) {

    for (let index in paramOptions) {
        let tempParam = paramOptions[index];
        let paramCode = tempParam.code;
        let paramName = tempParam.name;
        //校验规则
        let validate = tempParam.validate;
        if (validate != null && typeof validate !== 'undefined') {
            for (let paramNameIndex in obj) {
                if (paramNameIndex === paramCode) {
                    //字段名称匹配

                    let columnValue = obj[paramNameIndex]

                    let result = this.defaultValidate(paramName, columnValue, validate)
                    if (result.flag !== true) {
                        //校验不通过,弹框提示
                        this.$error({
                          title: '提示',
                          content: result.errorMsg || (paramName + "校验失败"),
                        });
                        return false;
                    }

                }

            }
        }

    }

    return true;


};


/**
  * 规则校验函数
  */
commonUtil.defaultValidate = function (columnName, columnValue, conditions) {

    let flag = true;
    let errorMsg = "";

    //校验条件,竖线分割,使用内置条件校验
    let conditionsStr = (conditions || "");
    let startIndex = conditionsStr.indexOf("|");

    let conditionParam = [];
    if (startIndex !== -1) {
        conditionParam[0] = conditionsStr.slice(0, startIndex);
        if (conditionsStr.length > startIndex) {
            conditionParam[1] = conditionsStr.slice(startIndex + 1, conditionsStr.length);
        }
        // conditionParam = conditionsStr.split("|");
    } else {
        conditionParam[0] = conditionsStr;
    }

    for (let index in conditionParam) {
        if (flag === false) {
            break;
        }
        let param = conditionParam[index];
        //冒号分割key和value
        let tubboParam = (param || ":").split(":");
        let key = tubboParam[0];
        let value = tubboParam[1];

        //key 是检查条件,value是检查条件约束
        if (key === "required") {
            //是否必填
            if (columnValue === null || typeof columnValue === "undefined"
                || columnValue === ""
                || (columnValue instanceof Array && columnValue.length === 0)) {
                //校验不通过
                errorMsg = columnName + "必填!";
                flag = false;
            }
        } else {
            if (columnValue === null || typeof columnValue === "undefined"
                || columnValue === ""
                || (columnValue instanceof Array && columnValue.length === 0)) {
                //空值,继续其他校验
                break;
            }
        }
        switch (key) {
            //自定义表达式
            case "regex":
                let regexValue = new RegExp(value)
                if (!regexValue.test(columnValue)) {
                    //校验不通过
                    errorMsg = columnName + "规则校验不通过!";
                    flag = false;
                }
                break;
            //after{target} - 比target要大的一个合法日期，格式(DD/MM/YYYY)
            case "after":
                break;
            //alpha - 只包含英文字符
            case "alpha":
                break;
            //alpha_dash - 可以包含英文、数字、下划线、破折号
            case "alpha_dash":
                break;
            //alpha_num - 可以包含英文和数字
            case "alpha_num":
                break;
            //before:{target} - 和after相反
            case "before":
                break;
            //between:{min},{max} - 在min和max之间的数字
            case "between":
                let betweenNum = value.split(",");
                let minNum = betweenNum[0];
                let maxNum = betweenNum[1];

                if (Number(columnValue) > maxNum && Number(columnValue) < minNum) {
                    //校验不通过
                    errorMsg = columnName + "-数字范围校验不通过!,数字范围必须是:[" + minNum + "," + maxNum + "]";
                    flag = false;
                }

                break;
            //confirmed:{target} - 必须和target一样
            case "confirmed":
                break;
            //date_between:{min,max} - 日期在min和max之间
            case "date_between":
                break;
            //date_format:{format} - 合法的format格式化日期
            case "date_format":
                break;
            //decimal:{decimals?} - 数字，而且是decimals进制
            case "decimal":
                break;
            //digits:{length} - 长度为length的数字
            case "digits":
                if (value != null && typeof value !== 'undefined') {
                    if (columnValue.length !== Number(value)) {
                        //校验不通过
                        errorMsg = columnName + "-数字长度校验不通过!,长度必须是:" + value;
                        flag = false;
                    }
                } else {
                    let digitsRegex = /^[0-9]*$/;
                    if (!digitsRegex.test(columnValue)) {
                        //校验不通过
                        errorMsg = columnName + "-纯数字校验不通过!";
                        flag = false;
                    }
                }

                break;
            //dimensions:{width},{height} - 符合宽高规定的图片
            case "dimensions":
                break;
            //email - 不解释
            case "email":
                let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if (!emailRegex.test(columnValue)) {
                    //校验不通过
                    errorMsg = columnName + "-邮箱格式校验不通过!";
                    flag = false;

                }
                break;
            //ext:[extensions] - 后缀名
            case "ext":
                break;
            //image - 图片
            case "image":
                break;
            //in:[list] - 包含在数组list内的值
            case "in":
                break;
            //ip - ipv4地址
            case "ip":
                break;
            //max:{length} - 最大长度为length的字符
            case "max":
                break;
            //mimes:[list] - 文件类型
            case "mimes":
                break;
            //min - max相反
            case "min":
                break;
            //mot_in - in相反
            case "mot_in":
                break;
            //numeric - 只允许数字
            case "numeric":
                break;
            //size:{kb} - 文件大小不超过
            case "size":
                break;
            //url:{domain?} - (指定域名的)url
            case "url":
                break;
            //phone
            case "phone":
                let phoneRegEx = /^1\d{10}$/;

                if (!phoneRegEx.test(columnValue)) {
                    //校验不通过
                    errorMsg = columnName + "-手机号格式校验不通过!";
                    flag = false;

                }
                break;
            default:
                break;

        }
    }

    //返回结果对象类型
    let result = {flag: flag, errorMsg: errorMsg};
    return result;
};

/**
  * 请求对象,属性是array,转为逗号分隔
  */
commonUtil.propertyArraySplit = function (obj) {

    let requestParam = {};

    for (let index in obj) {
        let tempItem = obj[index];
        if (tempItem instanceof Array) {
            //属性是数组的话,逗号粉盒
            requestParam[index] = tempItem.join(",")
        } else {
            requestParam[index] = tempItem;
        }
    }
    return requestParam;

};

/**
  * 数组剔重
  */
commonUtil.uniqueArray = function (array) {
    let n = [];//临时数组
    for (let i = 0; i < array.length; i++) {
        if (n.indexOf(array[i]) == -1) n.push(array[i]);
    }
    return n;
};
/**
  * 把空字符串,设置为null,避免后台转json错误,比如空字符串转数字报错
  */
commonUtil.blankToNull = function (obj) {
    if (obj instanceof Array) {
        for (let index in obj) {
            let tempItem = obj[index];
            for (let key in tempItem) {
                let tempObj = tempItem[key];
                if (tempObj === "") {
                    tempItem[key] = null;
                }
            }
        }
    } else {
        for (let key in obj) {
            let tempObj = obj[key];
            if (tempObj === "") {
                obj[key] = null;
            }
        }
    }

};


/**
  * 获取环境前缀,是dev,test,还是线上环境(线上没前缀)
  * @returns {string}
  */
commonUtil.getEvt = function () {
    let href = window.location.href;
    let EVT = '';
    if (href.indexOf('http://localhost') > -1) {
        //本地测试环境
        if (href.indexOf("http://localhost") > -1) {
            EVT = 'dev';
        } else if (href.indexOf("http://localhost") > -1) {
            EVT = 'dev';
        }
        return EVT;
    } else if (href.indexOf('https://') > -1) {
        // 测试环境
        if (href.indexOf('https://test') > -1 && href.indexOf('https://test.') === -1) {
            EVT = 'test';
            // dev环境
        } else if (href.indexOf('https://dev') > -1 && href.indexOf('https://dev.') === -1) {
            EVT = 'dev';
        } else {
            EVT = ''
        }
        return EVT;
    } else {
        // 测试环境
        if (href.indexOf('http://test') > -1 && href.indexOf('http://test.') === -1) {
            EVT = 'test';
            // dev环境
        } else if (href.indexOf('http://dev') > -1 && href.indexOf('http://dev.') === -1) {
            EVT = 'dev';
        } else {
            EVT = ''
        }
        return EVT;
    }


};

// 设置cookie   
commonUtil.setCookie = function(name,value){
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days*24*60*60*1000);
  document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString()
}

commonUtil.getCookie = function(name){ 
  var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)"); 
  return (arr=document.cookie.match(reg))?unescape(arr[2]):null;
}


export default commonUtil;



